import { ThunkActionCreator } from 'src/store/types';
import {
  describeUserSpecificIntentActions,
  UpdateUserSpecificIntentParams,
  updateUserSpecificIntentActions,
  APIError,
  clearUserPreSpecificIntentActions,
} from './userSpecificIntent.action';
import {
  updateUserSpecificIntents as _update,
  getUserSpecificIntents
} from 'src/services/userSpecificIntent/userSpecificIntent';
import { Dispatch } from 'redux';
import {
  currentAppSession,
} from 'src/utilities/storage';
import { getUserSpecificIntentBySession, updateUserSpecificIntentInSession, updateUserSpecificIntentInSessionPromise } from 'src/store/siteConfigurator/userSpecificIntent/userSpecificIntent.sessions';
import { createRequestThunk } from 'src/store/store.helpers';
import { notHasWorkflowLoanActive } from 'src/features/utilities';
import { head, pathOr, values } from 'ramda';
import { isNotEmpty } from 'src/utilities/hasValue';

/**
 * Async
 */

const _get = (loanId: string) => {
  return getUserSpecificIntents(loanId)
    .then((res: any) => {
      return { data: res };
    })
    .catch((err: any) => {
      return err;
    });
};

export const updateUserSpecificIntent = createRequestThunk<
  UpdateUserSpecificIntentParams,
  any,
  APIError[]
>(updateUserSpecificIntentActions, ({ ...data }) => {
  return updateWorkflowIntentBasedOnAuthType(data)
});

const updateWorkflowIntentBasedOnAuthType = (data: any) => {
  const { loanRoleId } = currentAppSession();
  return notHasWorkflowLoanActive() || isNotEmpty(loanRoleId)
    ? updateUserSpecificIntentInSession(data)
    : _update(loanRoleId, data);
};

export const requestUserSpecificIntent: ThunkActionCreator<Promise<any>, any> =
  (loanId: string) => async (dispatch: Dispatch<any>, _getStore: any) => {

    dispatch(describeUserSpecificIntentActions.started(true));
    return _get(loanId)
      .then((response) => {
        dispatch(describeUserSpecificIntentActions.done({ result: { items: [response.data] } }));
        return response;
      })
      .catch((err) => {
        dispatch(describeUserSpecificIntentActions.failed({ error: err }));
        return err;
      });
  };


export const requestUserPreSpecificIntent: ThunkActionCreator<Promise<any>> =
  () => async (dispatch: Dispatch<any>, _getStore: any) => {
    dispatch(describeUserSpecificIntentActions.started(getUserSpecificIntentBySession()));
    return updateUserSpecificIntentInSessionPromise(
      getUserSpecificIntentBySession()
    ).then((data: any) => {
      dispatch(describeUserSpecificIntentActions.done({ result: { items: [data] } }));
      return data
    }).catch((err: any) => {
      dispatch(describeUserSpecificIntentActions.failed({ error: err }));
      return err;
    });
  };



export const clearUserPreSpecificIntent: ThunkActionCreator<Promise<any>> =
  () => async (dispatch: Dispatch<any>, _getStore: any) => {
    dispatch(clearUserPreSpecificIntentActions.done(getUserSpecificIntentsFromStoreOrSession(_getStore)));
  };


/**
 * This function retrieves user specific intents from the store or session.
 * If the user specific intents are present in the session, it returns those.
 * Otherwise, it retrieves the user specific intents from the store and returns
 * @param _getStore - The Redux store's getState function.
 * @returns The user specific intents from the store or session.
 */
const getUserSpecificIntentsFromStoreOrSession = (_getStore: any) => {
  return  isNotEmpty(getUserSpecificIntentBySession()) ? getUserSpecificIntentBySession() : head(values(pathOr({}, ["__resources", "userSpecificIntent", "itemsById"], _getStore())))
}


/**
upsertUserSpecificIntents is used to update list of workflow_intents on reducer state
@param data { list }
*/
export const upsertUserSpecificIntents = (data: { items: any[] }) => (
  dispatch: Dispatch<any>
) => {
  dispatch(describeUserSpecificIntentActions.done({ result: data }));
};


/**
upsertUserSpecificIntentUpdate is used to update a single item on reducer state
@param data { object } single user's workflow_intents item to update on state itemsById
*/
export const upsertUserSpecificIntentUpdate = createRequestThunk(
  updateUserSpecificIntentActions, async ({ ...data }) => {
    return Promise.resolve(data);
  });

/**
updateWorkflowLoading is used to update loading of workflow_intents on reducer state
@param data { list }
*/
export const updateWorkflowLoading = (data: any) => (
  dispatch: Dispatch<any>
) => {
  dispatch(updateUserSpecificIntentActions.started(true));
}; 